import React from "react";
import { useTranslation } from "react-i18next";
import { useParallax } from "react-scroll-parallax";

import { SectionIds } from "@constants/sectionIds";

import "./ApiIntegration.scss";

const ApiIntegration = () => {
  const { t } = useTranslation("landingPage");

  const { ref } = useParallax({
    speed: -15,
    scale: [1.05, 1, "easeOutCubic"],
    shouldAlwaysCompleteAnimation: true
  });

  return (
    <section id={SectionIds.ApiIntegration} className="api-integration">
      <div className="api-integration-background">
        <img ref={ref as any} src="/images/layouts/api-integration-bg.jpg" alt="Api integration" className="bg-image" />
        <div className="bg-blur" />
      </div>

      <div className="api-integration-main">
        <div className="main-content">
          <h2>{t("apiIntegration.title")}</h2>

          <p className="p0 mt-8">{t("apiIntegration.description")}</p>
        </div>

        <div className="main-schema-box">
          <img src="/images/layouts/api-integration-schema.svg" alt="Api integration schema" className="image-schema" />
        </div>
      </div>
    </section>
  );
};

export default ApiIntegration;
